import React from 'react'
import PropTypes from 'prop-types'
import { inject, observer } from 'mobx-react'

@inject("store")
@observer
export default class AddOnCategory extends React.Component {
  static propTypes = {
    addOnCategory: PropTypes.object.isRequired,
    textColor: PropTypes.string,
    children: PropTypes.any
  }

  render() {
    const { children, addOnCategory, textColor, store } = this.props
    const { showCategoryHeaders } = store

    let titleStyle = {...styles.title}
    if(textColor) {
      titleStyle.color = textColor
      titleStyle.borderBottom = `1px solid ${textColor}`
    }

    return (
      <div style={styles.container}>
        { showCategoryHeaders &&
          <div style={titleStyle}>{ addOnCategory.attributes.name }</div>
        }
        <div>
          { children }
        </div>
      </div>
    )
  }
}

const styles = {
  title: {
    fontSize: 30,
    color: "#000",
    fontWeight: "bold",
    borderBottom: "1px solid #777",
    marginBottom: 20
  },
  container: {
    paddingBottom: 60
  }
}
